import { DropdownMenuItem } from "@acdc2/ui/components/dropdown-menu";
import { mdiLogin } from "@mdi/js";
import { Icon } from "@mdi/react";
import { useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";

export function ViewerLoginDropdownMenuItem() {
  const { t } = useTranslation();
  const auth = useAuth();

  const onClick = () => {
    auth.signinRedirect();
  };

  return (
    <DropdownMenuItem onClick={onClick}>
      <Icon path={mdiLogin} size="1.25rem" />
      {t("ViewerLoginDropdownMenuItem.label")}
    </DropdownMenuItem>
  );
}
